import React from 'react';
import { Link } from 'react-router-dom';
import { posts } from './posts';
import BlogPreview from './BlogPreview';

const BlogList = () => {
  return (
    <div className="min-h-screen bg-cream-100 relative">
      {/* Grain texture overlay */}
      <div className="grain-overlay" aria-hidden="true"></div>

      {/* Header */}
      <header className="pt-16 md:pt-24 pb-12 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="animate-on-load animate-fade-in-up">
            <Link
              to="/"
              className="font-body text-ink-muted hover:text-ink text-sm uppercase tracking-widest mb-6 inline-block transition-colors"
            >
              ← Back to Home
            </Link>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-ink tracking-tight">
              Writing
            </h1>
            <p className="font-body text-xl md:text-2xl text-ink-muted italic mt-4 max-w-xl">
              Thoughts on technology, leadership, and building products.
            </p>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="px-6 md:px-12 pb-24">
        <div className="max-w-3xl mx-auto">
          <div className="editorial-divider mb-12"></div>
          
          {posts.length === 0 ? (
            <p className="font-body text-ink-light italic">No posts yet. Check back soon!</p>
          ) : (
            <div className="space-y-8">
              {posts.map((post, index) => (
                <React.Fragment key={post.slug}>
                  <BlogPreview post={post} index={index} />
                  {index < posts.length - 1 && (
                    <div className="editorial-divider my-8"></div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-cream-300 bg-cream-200/50">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-12">
          <p className="font-body text-center text-ink-muted text-sm tracking-wide">
            © {new Date().getFullYear()} Teddy Marchildon
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BlogList;



